import { Alert, Button, Space, Typography } from "antd";
import dayjs from "dayjs";
import EmailPreviewFrame from "../../../shared/emailEditor/EmailPreviewFrame";

const EmailDeliveryReview = ({ renewal, isAdmin, resolving, onResolve }) => (
  <div style={{ maxWidth: 800 }}>
    <Alert
      type="warning"
      showIcon
      message="Email delivery needs review"
      description="This email may have reached the customer. Check the outbound mail record before another send. An attempt still in progress can be reviewed after five minutes."
      style={{ marginBottom: 16 }}
    />
    <div style={{ marginBottom: 12 }}>
      <strong>To:</strong> {renewal.email ?? "—"}
      {renewal.email_delivery_started_at && (
        <span>
          {" · Started "}
          {dayjs(renewal.email_delivery_started_at).format("MMM D, YYYY h:mm A")}
        </span>
      )}
    </div>
    {isAdmin ? (
      <Space style={{ marginBottom: 16 }}>
        <Button loading={resolving} onClick={() => onResolve("sent")}>
          Mark as sent
        </Button>
        <Button loading={resolving} onClick={() => onResolve("retry")}>
          Allow retry
        </Button>
      </Space>
    ) : (
      <Typography.Text type="secondary">
        Ask an admin to check delivery and resolve this renewal.
      </Typography.Text>
    )}
    {renewal.sent_body && (
      <>
        <div style={{ marginBottom: 8 }}>
          <strong>Prepared subject:</strong> {renewal.sent_subject}
        </div>
        <EmailPreviewFrame html={renewal.sent_body} title="Prepared email" />
      </>
    )}
  </div>
);

export default EmailDeliveryReview;
